<fgb-banner [pageTitle]="'brand.page.title' | translate" />

<fgb-page-header [pageTitle]="'brand.page.title'" [backButtonLink]="'/'" />

<div class="container">
  <fgb-brand-list></fgb-brand-list>
</div>
